import { Grid, TextField } from '@mui/material';
import { useFormikContext, Field } from 'formik';
import { useTranslation } from 'react-i18next';
import { translations } from 'locales/i18n';
import ErrorMarker from '../components/ErrorMarker';

export default function ContactData() {
  const { errors, touched }: any = useFormikContext<any>();
  const { t } = useTranslation();

  return (
    <>
      <Grid container className="register-form__description">
        {t(translations.pages.login.formDescriptions.contactData())}
      </Grid>
      <Grid container>
        <Grid item xs={11} md>
          <Field
            className="register-form__field"
            label={t(translations.common.firstName())}
            name="contactData.firstName"
            as={TextField}
            error={touched.contactData?.firstName && errors.contactData?.firstName}
            variant="outlined"
            size="small"
            fullWidth
            required
          />
        </Grid>
        {touched.contactData?.firstName && errors.contactData?.firstName && (
          <ErrorMarker message={errors.contactData?.firstName} />
        )}
        <Grid item xs={11} md>
          <Field
            className="register-form__field"
            label={t(translations.common.lastName())}
            name="contactData.lastName"
            as={TextField}
            error={touched.contactData?.lastName && errors.contactData?.lastName}
            variant="outlined"
            size="small"
            fullWidth
            required
          />
        </Grid>
        {touched.contactData?.lastName && errors.contactData?.lastName && (
          <ErrorMarker message={errors.contactData?.lastName} />
        )}
      </Grid>
      <Grid container>
        <Grid item xs={11} md>
          <Field
            className="register-form__field"
            label={t(translations.common.email_short())}
            name="contactData.email"
            as={TextField}
            error={touched.contactData?.email && errors.contactData?.email}
            variant="outlined"
            size="small"
            fullWidth
            required
          />
        </Grid>
        {touched.contactData?.email && errors.contactData?.email && (
          <ErrorMarker message={errors.contactData?.email} />
        )}
        <Grid item xs={11} md>
          <Field
            className="register-form__field"
            label={t(translations.common.phone())}
            name="contactData.phone"
            as={TextField}
            error={touched.contactData?.phone && errors.contactData?.phone}
            variant="outlined"
            size="small"
            fullWidth
            required
          />
        </Grid>
        {touched.contactData?.phone && errors.contactData?.phone && (
          <ErrorMarker message={errors.contactData?.phone} />
        )}
      </Grid>
      <Grid container>
        <Grid item xs>
          <Field
            className="register-form__field"
            label={t(translations.common.position())}
            name="contactData.position"
            as={TextField}
            error={touched.contactData?.position && errors.contactData?.position}
            variant="outlined"
            size="small"
            fullWidth
            required
          />
        </Grid>
        {touched.contactData?.position && errors.contactData?.position && (
          <ErrorMarker message={errors.contactData?.position} />
        )}
      </Grid>
      <Grid container className="register-form__info">
        * {t(translations.common.requiredFields())}
      </Grid>
    </>
  );
}
